import isFeatureEnabled from '@get-bridge/learn-legacy-shared/dist/utils/isFeatureEnabled';
import author from '../author/learn-runtime.js';
import authorization from '../authorization/learn-runtime.js';
import insights from '../insights/learn-runtime.js';
import myLearning from '../my-learning/learn-runtime.js';
import main from '../main/learn-runtime.js';
function getApps() {
  const apps = [author, authorization, insights, myLearning, main];
  return apps;
}

function evaluateAccessRule(rule) {
  if (rule.hasOwnProperty('feature')) {
    return isFeatureEnabled(rule.feature);
  } else if (rule.hasOwnProperty('feature_disabled')) {
    return !isFeatureEnabled(rule.feature_disabled);
  }
  console.error(`learnRuntime: Unknown access_rule ${rule}`);
  return false;
}

function evaluatePath(pathname, path) {
  if (!pathname.match(path.path)) {
    return false;
  }
  if (path.hasOwnProperty('accessRules')) {
    return path.accessRules.every(evaluateAccessRule);
  }
  return true;
}

function getAppInfo(pathname) {
  return getApps().find(app =>
    app.pathPatterns.find(path => {
      if (path.hasOwnProperty('path')) {
        return evaluatePath(pathname, path);
      }
      return pathname.match(path);
    }),
  );
}

export { getApps, getAppInfo };



// WEBPACK FOOTER //
// ./jsapp/learnRuntime/getAppInfo.js